import { Fab, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

const FloatingActionButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useKindeAuth();

  // Don't show FAB on certain pages or if not authenticated
  const hiddenPaths = ["/login", "/signup", "/entries/add", "/profile"];
  const shouldShow =
    isAuthenticated && !hiddenPaths.includes(location.pathname);

  if (!shouldShow) return null;

  const handleAddEntry = () => {
    navigate("/entries/add");
  };

  return null;
  // <Tooltip title="Add New Entry" placement="left">
  //   <Fab
  //     color="primary"
  //     aria-label="add entry"
  //     onClick={handleAddEntry}
  //     sx={{
  //       position: "fixed",
  //       bottom: 24,
  //       right: 24,
  //       zIndex: 1000,
  //     }}
  //   >
  //     <AddIcon />
  //   </Fab>
  // </Tooltip>
};

export default FloatingActionButton;
